var capitalizeFirstCharacter = function capitalizeFirstCharacter(text) {
  return text.length ? text[0].toUpperCase() + text.substring(1) : '';
};

export default capitalizeFirstCharacter;